<script>
/**
 * @Author: zhangxiaojian
 * @Date: 2025/7/1
 * @LastEditors: zhangxiaojian
 * @Description 知识问答-问题提示
 **/
import { AIDify } from '@apis'
export default {
  name: 'QuestionTip',
  props: {
    messageId: {
      // 最后一轮的消息ID
      type: String,
      required: true
    }
  },
  emits: [
    /**
     * 按提示开始问答
     * @param {string} question 提示的内容
     */
    'newQuestion'
  ],
  inject: [
    /**
     * 设置滚动条滚动到底部
     */
    'scrollToBottom'
  ],
  mounted() {
    this.getQuestionTip()
  },
  data() {
    return {
      list: []
    }
  },
  methods: {
    /**
     * 获取ai问答问题提示
     * @returns {Promise<void>}
     */
    async getQuestionTip() {
      const res = await AIDify.getSuggested({
        params: {
          messageId: this.messageId
        }
      })
      if (res.data.status === 0) {
        this.list = res.data.data
        this.$nextTick(() => {
          if (this.scrollToBottom) {
            this.scrollToBottom()
          }
        })
      } else {
        this.list = []
      }
    }
  }
}
</script>

<template>
  <div class="message-question-tip" v-if="list.length > 0">
    <div>您还可以试着问：</div>
    <div class="message-question-tip-list">
      <span
        v-for="item in list"
        :key="item"
        @click="$emit('newQuestion', item)"
        >{{ item }}</span
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
.message-question-tip {
  width: 100%;
  padding-left: 34px;
  margin-top: 10px;
  &-list {
    span {
      display: inline-block;
      background: #fff;
      line-height: 36px;
      padding: 0 10px;
      border-radius: 9px;
      margin: 10px 10px 10px 0;
      color: #7c90b3;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 36px;
      white-space: nowrap;
      max-width: 100%;
      box-shadow: 1px 0px 10px 0px rgba(0, 87, 184, 0.1);
      &:hover {
        color: #006bff;
        cursor: pointer;
      }
    }
  }
}
</style>
